import React from 'react';
import TooltipCutoff from '../../../../components/V2/Tooltip/TooltipCutoff';

const ColumnCampaignName = ({ original }) => {
  const campaignName = original.get('name');
  return <TooltipCutoff title={campaignName}>{campaignName}</TooltipCutoff>;
};

export default ColumnCampaignName;
